import { ROLES } from '@/common/constants';
import type { UserOption } from '@/otros-tramites/services/otrosTramitesService';

type RoleLike = string | { name?: string | null } | null | undefined;

export const normalizeUserRoles = (roles: RoleLike[] | undefined): string[] => {
  if (!Array.isArray(roles)) {
    return [];
  }

  return roles
    .map((role) => {
      if (typeof role === 'string') {
        return role.trim();
      }

      if (role && typeof role === 'object' && typeof role.name === 'string') {
        return role.name.trim();
      }

      return '';
    })
    .filter((roleName): roleName is string => roleName.length > 0);
};

export const isAssignableAssignedUser = (user: UserOption): boolean => {
  const roles = normalizeUserRoles(user.roles);
  if (roles.length === 0) {
    return false;
  }

  return roles.some((roleName) => !(ROLES.CONTEXTUAL_ROLES as readonly string[]).includes(roleName));
};
